<template>
  <div class="tutorial-matching-list">
    <v-card class="text-center pb-2 px-5" style="">
      <v-card-text>
        <v-row no-gutters>
          <v-col class="mr-3">
            <div class="text-overline">Tutorien</div>
            <draggable
              class="dragArea list-group"
              :list="timeslots"
              group="people"
            >
              <v-card
                class="list-group-item d-flex justify-space-between"
                v-for="element in timeslots"
                :key="element.id"
              >
                {{ timeslotToName(element) }}
                <v-icon dense>mdi-help</v-icon>
              </v-card>
            </draggable>
          </v-col>
          <v-col class="mr-3">
            <div class="text-overline">Ja</div>
            <draggable
              class="dragArea list-group"
              :list="preferences"
              group="people"
            >
              <v-card
                class="list-group-item d-flex justify-space-between"
                v-for="element in preferences"
                :key="element.id"
              >
                {{ timeslotToName(element) }}
                <v-icon dense color="success">mdi-check-bold</v-icon>
              </v-card>
            </draggable></v-col
          >
          <v-col>
            <div class="text-overline">Nein</div>
            <draggable
              class="dragArea list-group"
              :list="notAviliableList"
              group="people"
            >
              <v-card
                class="list-group-item d-flex justify-space-between"
                v-for="element in notAviliableList"
                :key="element.id"
              >
                <div>{{ timeslotToName(element) }}</div>
                <v-icon dense color="alert">mdi-close-thick</v-icon>
              </v-card>
            </draggable></v-col
          >
        </v-row>
        <v-btn
          block
          depressed
          color="tertiary"
          class="mt-8 white--text"
          @click="uploadPreferences"
          >Senden</v-btn
        >
      </v-card-text>
      <div class="csc-mailform-field">
        <button class="csc-mailform-submit" @click="uploadPreferences">
          Speichern
        </button>
      </div>
    </v-card>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      timeslots: [],
      preferences: [],
      notAviliableList: [],
      controlOnStart: true,
    };
  },
  mounted() {
    Promise.allSettled([
      this.$axios.get(`matching/${this.$route.params.id}/timeslots`),
      this.$axios.get(`matching/${this.$route.params.id}/preference`),
    ]).then((results) => {
      this.timeslots = results[0].value.data;
      if (results[1].status == "rejected") {
        // ths user hasn't participite the matching yet
        this.preferences = [];
      } else {
        const preferences = results[1].value.data;
        const preferenceIds = preferences.preference_list.map((j) => j.id);
        const unavailablePreferences = preferences.not_available_timeslot.map(
          (j) => j.id
        );

        this.preferences = results[1].value.data.preference_list;
        this.notAviliableList = results[1].value.data.not_available_timeslot;

        this.timeslots = this.timeslots
          .filter((i) => preferenceIds.indexOf(i.id) == -1)
          .filter((i) => unavailablePreferences.indexOf(i.id) == -1);
      }
    });
  },
  methods: {
    timeslotToName: (timeslot) => {
      return (
        `${timeslot.day} ${timeslot.start}, ` +
        `${timeslot.format}`.toLowerCase()
      );
    },
    uploadPreferences: function () {
      const available = this.preferences.map((i) => i.id);
      const unavailable = this.notAviliableList.map((i) => i.id);
      this.$axios
        .post(`matching/${this.$route.params.id}`, {
          available,
          unavailable,
        })
        .then(this.$router.push({ name: "tutorials.matching" }));
    },
  },
};
</script>

<style scoped>
.list-group-item {
  padding: 0.75rem 1.25rem;
  border: thin solid rgba(0, 0, 0, 0.125);
  border-radius: 5px;
  margin-bottom: 5px;
}

.dragArea {
  min-height: 40vh;
  border: solid rgb(172, 172, 172);
  border-width: thin;
  border-radius: 5px;
  padding: 1rem;
}

button {
  background-color: transparent !important;
}

.dragArea .list-group-item {
  cursor: pointer;
}
</style>
